import moment from "moment";
import React from "react";
import { Link } from "react-router-dom";
import styled from "styled-components";

import { colors } from "../../design";
import { ITalk } from "../../interfaces";
import Image from "../atoms/Image";
import Text from "../atoms/Text";
import UserNameAndStatus from "../molecules/UserNameAndStatus";

interface IProps {
  talk: ITalk;
}
const Talk: React.FC<IProps> = ({ talk, ...props }) => {
  const { user, latestMessage } = talk;
  const time = latestMessage ? moment(latestMessage.timestamp) : null;
  return (
    <>
      <MessageLink to={`users/${talk.user.id}/messages`}>
        <UserIcon {...props} src={user.pictureUrl} />
        <TalkItemLeft>
          <TalkItemText className="talk-item__text">
            <UserStatusAlign>
              <UserNameAndStatus user={user} />
            </UserStatusAlign>
          </TalkItemText>
          <UserText>
            {latestMessage &&
              latestMessage.dataType === "text" &&
              `${latestMessage.value.substr(0, 15)}...`}
            {latestMessage &&
              latestMessage.dataType === "image" &&
              "（画像が送信されました）"}
          </UserText>
        </TalkItemLeft>
        <TalkItemRight>
          <Time>{time && time.format("M/D H:mm")}</Time>
          {/* unreadCount > 0 && <UnreadCount>{unreadCount}</UnreadCount> */}
        </TalkItemRight>
      </MessageLink>
    </>
  );
};

const UserIcon = styled(Image)`
  border-radius: 50%;
  width: 50px;
  height: 50px;
  object-fit: contain;
`;

const TalkItemText = styled.div``;

const UserText = styled(Text)`
  color: ${colors.lightGray};
`;

const UserStatusAlign = styled.div`
  color: #000;
  display: flex;
`;

const TalkItemLeft = styled.div`
  display: flex;
  flex-direction: column;
  margin-left: 12px;
  flex-grow: 1;
`;

const TalkItemRight = styled.div`
  display: flex;
  width: 80px;
  text-align: right;
  color: ${colors.lightGray};
  flex-direction: column;
  align-items: flex-end;
`;

const Time = styled(Text)`
  line-height: 1.4;
  height: 32px;
  margin: 0px;
  overflow: hidden;
  color: ${colors.lightGray};
  font-size: 13px;
`;

const MessageLink = styled(Link)`
  display: flex;
  align-items: center;
  width: 100%;
`;

export default Talk;
